//frontend/src/services/api.js

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://evisa-backend-s6e3.onrender.com/api';

const api = axios.create({
    baseURL: API_URL,
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        // Si c'est du FormData, NE PAS DÉFINIR Content-Type
        // Axios le gérera automatiquement avec les bonnes boundaries
        if (config.data instanceof FormData) {
            // Ne rien faire - laisser le navigateur définir le Content-Type
            // Le navigateur ajoutera automatiquement la boundary nécessaire
        } else {
            // Pour les autres types de requêtes, utiliser JSON
            config.headers['Content-Type'] = 'application/json';
        }
        
        return config;
    },
    (error) => Promise.reject(error)
);



export default api;